module.exports = __webpack_public_path__ + "static/media/01.e678586f.png";